import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import Drawer from '@material-ui/core/Drawer';
import { withStyles } from '@material-ui/core/styles';

import { logoutRoutine } from '../../redux/routines';
import { hideDialog, showDialog } from '../../redux/actions/dialogs';
import AccountsService from '../../utils/AccountsService';
import FindJobDialog from '../Jobs/FindJobDialog';
import ProfileDialog from '../Authentication/ProfileDialog';
import ConfirmDialog from '../Common/ConfirmDialog';
import AlertDialog from '../Common/AlertDialog';
import JobDialog from '../Jobs/JobDialog';
import TaskUploadDialog from '../Tasks/TaskUploadDialog';
import AddressDialog from '../Addresses/AddressDialog';
import ContactDialog from '../Contacts/ContactDialog';
import UpgradeDialog from '../Admin/Billing/UpgradeDialog';
import CreditCardCapture from '../Admin/Billing/CreditCardDialog';
import QualityControlQuestionDialog from '../Admin/JobProfiles/QuestionDialog';
import SendEmailDialog from '../Common/SendEmailDialog';
import SendSmsDialog from '../Common/SendSmsDialog';

import MenuBar from './MenuBar';
import PrimarySearchAppBar from './PrimarySearchAppBar';
import {
  ACCOUNT_DIALOG,
  ADDRESS_DIALOG,
  ALERT_DIALOG,
  CONFIRM_DIALOG,
  CONTACT_DIALOG,
  CREDIT_CARD_DIALOG,
  CUSTOMER_DIALOG,
  FIND_JOB_DIALOG,
  GENERATE_LABELS_DIALOG,
  IDENTITY_DIALOG, JOB_DIALOG,
  PROFILE_DIALOG,
  QUALITY_CONTROL_QUESTION_DIALOG,
  SEND_EMAIL_DIALOG,
  SEND_SMS_DIALOG,
  TASK_UPLOAD_DIALOG,
  UPGRADE_DIALOG
} from '../../redux/constants/dialogs';
import { getDialogContextValue, isDialogVisibleSelector } from '../../redux/selectors';
import CustomerDialog from '../Customers/CustomerDialog';
import IdentityDialog from '../Common/IdentityDialog';
import { toJS } from '../../utils/helper';
import { Elements } from 'react-stripe-elements';
import GenerateLabelsDialog from '../Jobs/GenerateLabelsDialog';

const drawerWidth = 240;

const styles = theme => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    minHeight: '100vh',
  },
  drawerPaper: {
    position: 'relative',
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
    minWidth: 0, // So the Typography noWrap works
  },
  toolbar: theme.mixins.toolbar,
});

class Dashboard extends Component {

  static propTypes = {
    logoutUser: PropTypes.func.isRequired,
    showDialog: PropTypes.func.isRequired,
    children: PropTypes.any.isRequired,
    title: PropTypes.string.isRequired,
    push: PropTypes.func.isRequired,

    account: PropTypes.object.isRequired,
  };

  state = {
    openReportsMenu: false,
    account: AccountsService.getAccount(),
  };

  handleLogOut = () => {
    this.props.logoutUser();
  };

  handleReportsClick = () => {
    this.setState({
      openReportsMenu: !this.state.openReportsMenu,
    });
  };

  handleOnRequestChange = (value) => {
    console.log('handleOnRequestChange', value);
    this.setState({
      openReportsMenu: value,
    });
  };

  handleReportSelect = (report) => {
    console.log('handleReportSelect', report);
  };

  // handleShowJobReport = (report) => {
  //   this.props.showDialog(FIND_JOB_DIALOG, {
  //     report,
  //     onSelect: (jobId) => this.props.push(`/reports/${report}/${jobId}`),
  //   });
  // };

  render() {
    const { account, classes, logoutUser, showDialog, isDialogVisible, getDialogContextValue, path } = this.props;

    return (
      <div className={classes.root}>
        <PrimarySearchAppBar
          account={account}
          onLogout={logoutUser}
          showAccount={() => showDialog(ACCOUNT_DIALOG)}
          showProfile={() => showDialog(PROFILE_DIALOG)}
        />

        <Drawer
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <div className={classes.toolbar}/>
          <MenuBar
            path={path}
            navigateTo={this.props.push}
            findJob={(context) => this.props.showDialog(FIND_JOB_DIALOG, context)}
          />
        </Drawer>

        <main className={classes.content}>
          <div className={classes.toolbar}/>
          {this.props.children}
        </main>

        {isDialogVisible(FIND_JOB_DIALOG) ? <FindJobDialog/> : null}
        {isDialogVisible(PROFILE_DIALOG) ? <ProfileDialog/> : null}
        {isDialogVisible(CONFIRM_DIALOG) ? <ConfirmDialog/> : null}
        {isDialogVisible(ALERT_DIALOG) ? <AlertDialog/> : null}
        {isDialogVisible(TASK_UPLOAD_DIALOG) ? <TaskUploadDialog/> : null}
        {isDialogVisible(ADDRESS_DIALOG) ? <AddressDialog/> : null}
        {isDialogVisible(CONTACT_DIALOG) ? <ContactDialog/> : null}
        {/*{isDialogVisible(TAG_DIALOG) ? <TagDialog/> : null}*/}

        {isDialogVisible(UPGRADE_DIALOG) ? <UpgradeDialog/> : null}
        {isDialogVisible(CREDIT_CARD_DIALOG) ? <Elements><CreditCardCapture/></Elements> : null}
        {isDialogVisible(CUSTOMER_DIALOG) ? <CustomerDialog/> : null}
        {isDialogVisible(IDENTITY_DIALOG) ? <IdentityDialog
          identity={toJS(getDialogContextValue(IDENTITY_DIALOG, 'identity'))} hideDialog={hideDialog}/> : null}
        {isDialogVisible(QUALITY_CONTROL_QUESTION_DIALOG) ? <QualityControlQuestionDialog/> : null}
        {isDialogVisible(GENERATE_LABELS_DIALOG) ? <GenerateLabelsDialog/> : null}
        {isDialogVisible(SEND_SMS_DIALOG) ? <SendSmsDialog/> : null}
        {isDialogVisible(SEND_EMAIL_DIALOG) ? <SendEmailDialog/> : null}
        {isDialogVisible(JOB_DIALOG) ? <JobDialog/> : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    account: AccountsService.getAccount(),
    isDialogVisible: isDialogVisibleSelector(state),
    getDialogContextValue: getDialogContextValue(state),
    path: state.get('router').location.pathname,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    logoutUser: () => logoutRoutine.trigger({ redirect: true }),
    showDialog,
    push,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Dashboard));



// WEBPACK FOOTER //
// ./src/components/Dashboard/index.js